import { render, staticRenderFns } from "./RoleApplyRecordList.vue?vue&type=template&id=48069ff8&scoped=true"
import script from "./RoleApplyRecordList.vue?vue&type=script&lang=js"
export * from "./RoleApplyRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48069ff8",
  null
  
)

export default component.exports